// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import {UnsupportedChecklistKindErrorPage} from '@features/hroc-checklists'
import {FeatureTranslationsLoader} from '@hconnect/common/localization-loaders'
import {useFundamentalMuiTheme} from '@hconnect/uikit'
import {ThemeProvider} from '@mui/material'
import {Outlet, Route, RouteObject} from 'react-router'

import {tasksFeatureTranslations} from '../localization'
import {TaskChecklistPage, Tasks} from '../pages'

export const tasksChildRouteElements = (
  <>
    <Route index element={<Tasks />} />
    <Route path="checklist/:checklistId" element={<TaskChecklistPage />} />
    <Route
      path="checklist/:checklistId/unsupported-kind"
      element={<UnsupportedChecklistKindErrorPage />}
    />
  </>
)

const tasksChildRoutes: RouteObject[] = [
  {
    index: true,
    element: <Tasks />
  },
  {
    path: 'checklist/:checklistId',
    element: <TaskChecklistPage />
  },
  {
    path: 'checklist/:checklistId/unsupported-kind',
    element: <UnsupportedChecklistKindErrorPage />
  }
]

const SuiteTasksRouteWrapper = () => {
  return (
    <FeatureTranslationsLoader translations={tasksFeatureTranslations}>
      <ThemeProvider theme={useFundamentalMuiTheme()}>
        <Outlet />
      </ThemeProvider>
    </FeatureTranslationsLoader>
  )
}

export const tasksRoutes: RouteObject = {
  element: <SuiteTasksRouteWrapper />,
  children: tasksChildRoutes
}
